
export const MESSAGE_TYPES = [
  {
    key: "FI",
    imageClass: "ft-ordinary-image",
    title: "기본 텍스트형",
    description: "이미지, 동영상, 버튼 첨부가 가능한 기본형 메시지입니다.",
  },
  {
    key: "FW",
    imageClass: "ft-wide-image-image",
    title: "와이드 이미지형",
    description: "이미지 또는 동영상을 강조할 수 있습니다.",
  },
  {
    key: "FL",
    imageClass: "ft-wide-list-image",
    title: "와이드 리스트형",
    description: "다수의 소식을 리스트 형태로 구성할 수 있습니다.",
  },
  {
    key: "FC",
    imageClass: "ft-carousel-image",
    title: "캐러셀 피드형",
    description: "다수의 소식을 피드 형태로 보여줄 수 있습니다.",
  },
];
export const EVENT_TYPES = [
  {
    key: "roulette",
    imageClass: "roulette",
    title: "룰렛 이벤트",
    description: "룰렛을 돌리는 재미 요소로 오프라인 이벤트에 적합합니다.",
  },
  {
    key: "skip",
    imageClass: "skip",
    title: "바로 당첨 이벤트",
    description: "고객에게 게임 없이 바로 당첨하는 이벤트에 적합합니다.",
  },
  {
    key: "friends",
    imageClass: "friends",
    title: "친구 초대 이벤트",
    description: "고객에게 룰렛을 돌릴 수 있는 친구 초대 이벤트를 합니다",
  },
  {
    key: "lottery",
    imageClass: "lottery",
    title: "추첨 이벤트",
    description: "고객들이 응모 후 별도 추첨하는 이벤트입니다.",
  },
];
export const BENEFIT_TYPES = [
  {
    key: "DIRECT",
    imageClass: "benefit_direct",
    title: "직원 확인형",
    description: "직원이 직접 ‘사용 완료' 버튼을 통해 사용하는 혜택 입니다.",
  },
  {
    key: "DELIVERY",
    imageClass: "benefit_delivery",
    title: "고객 정보 수집형",
    description: "고객 정보를 최종 확인 받아 브랜드에서 직접 발송하는 형태의 혜택 입니다.",
  },
  {
    key: "CODE",
    imageClass: "benefit_code",
    title: "혜택 코드형",
    description: "발급된 쿠폰 코드를 통해 확인하는 쿠폰 코드형 혜택입니다.",
  },
  {
    key: "LINK",
    imageClass: "benefit_link",
    title: "링크 혜택형",
    description: "입력한 URL 페이지로 이동하여 혜택을 수령합니다.",
  },
  {
    key: "KAKAO",
    imageClass: "benefit_kakao",
    title: "카카오톡 선물하기",
    description: "카카오톡 선물하기로 고객에게 보냅니다.",
  },
];

export const MESSAGE_TARGET_FILTER = [
  { value: "respond_1",
    label: "1회 이상 메시지를 클릭한 고객",
    data: [
      { value: "1", label: "지난 1개월 간" },
      { value: "2", label: "지난 2개월 간" },
      { value: "3", label: "지난 3개월 간" },
      { value: "4", label: "지난 4개월 간" },
      { value: "5", label: "지난 5개월 간" },
      { value: "6", label: "지난 6개월 간" },
      { value: "7", label: "지난 7개월 간" },
      { value: "8", label: "지난 8개월 간" },
      { value: "9", label: "지난 9개월 간" },
      { value: "10", label: "지난 10개월 간" },
      { value: "11", label: "지난 11개월 간" },
      { value: "12", label: "지난 12개월 간" },
    ]
  },
  { value: "respond_2",
    label: "2회 이상 메시지를 클릭한 고객",
    data: [
      { value: "1", label: "지난 1개월 간" },
      { value: "2", label: "지난 2개월 간" },
      { value: "3", label: "지난 3개월 간" },
      { value: "4", label: "지난 4개월 간" },
      { value: "5", label: "지난 5개월 간" },
      { value: "6", label: "지난 6개월 간" },
      { value: "7", label: "지난 7개월 간" },
      { value: "8", label: "지난 8개월 간" },
      { value: "9", label: "지난 9개월 간" },
      { value: "10", label: "지난 10개월 간" },
      { value: "11", label: "지난 11개월 간" },
      { value: "12", label: "지난 12개월 간" },
    ]
  },
  { value: "respond_3",
    label: "3회 이상 메시지를 클릭한 고객",
    data: [
      { value: "1", label: "지난 1개월 간" },
      { value: "2", label: "지난 2개월 간" },
      { value: "3", label: "지난 3개월 간" },
      { value: "4", label: "지난 4개월 간" },
      { value: "5", label: "지난 5개월 간" },
      { value: "6", label: "지난 6개월 간" },
      { value: "7", label: "지난 7개월 간" },
      { value: "8", label: "지난 8개월 간" },
      { value: "9", label: "지난 9개월 간" },
      { value: "10", label: "지난 10개월 간" },
      { value: "11", label: "지난 11개월 간" },
      { value: "12", label: "지난 12개월 간" },
    ]
  },
  {
    value: "gender",
    label: "성별",
    data: [
      { value: "male", label: "남성" },
      { value: "female", label: "여성" },
    ],
  },
  {
    value: "age",
    label: "연령대",
    data: [
      { value: "15-19", label: "15~19세" },
      { value: "20-29", label: "20~29세" },
      { value: "30-39", label: "30~39세" },
      { value: "40-49", label: "40~49세" },
      { value: "50-59", label: "50~59세" },
      { value: "60-69", label: "60~69세" },
      { value: "70-79", label: "70~79세" },
      { value: "80-99", label: "80세~" },
      { value: "미수집", label: "미수집" }
    ],
  },
  { value: "entry_point", label: "진입점", data: [] },
  {
    value: "address",
    label: "배송지 주소",
    data: [],
  },
];
